(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chair-edit-hero"] && !Shopify.designMode) return;
  try {
    
  const initialiseChairHero = (root) => {
    if (!root || root.dataset.heroReady === 'true') return;
    root.dataset.heroReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-chair-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-chair-hero-dot]'));
    const cta = root.querySelector('[data-chair-hero-cta]');
    const ctaLabel = root.querySelector('[data-chair-hero-cta-label]');
    const ctaPrefix = root.dataset.ctaPrefix || 'Meet';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = root.dataset.autoplayEnabled === 'true' && !reducedMotion;
    const delay = Math.max(Number(root.dataset.autoplaySeconds) || 5, 3) * 1000;
    let activeIndex = 0;
    let timer;

    const showSlide = (index, resume = true) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      const activeSlide = slides[activeIndex];
      if (cta && ctaLabel) {
        const name = activeSlide.dataset.chairName || '';
        cta.href = activeSlide.dataset.chairAnchor || '#';
        cta.dataset.chair = activeSlide.dataset.chairHandle || '';
        ctaLabel.textContent = `${ctaPrefix} ${name}`;
      }
      if (resume) startAutoplay();
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (autoplay && slides.length > 1) timer = window.setInterval(() => showSlide(activeIndex + 1, false), delay);
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });
    root.addEventListener('shopify:block:select', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) showSlide(index, false);
      stopAutoplay();
    });
    startAutoplay();
  };

  const initialiseChairHeroes = (scope = document) => scope.querySelectorAll('[data-chair-hero]').forEach(initialiseChairHero);
  initialiseChairHeroes();
  document.addEventListener('shopify:section:load', (event) => initialiseChairHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas_delivery_announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeChristmasBanner() {
      document.querySelectorAll('.christmas-delivery-banner').forEach(banner => {
        if (banner.dataset.christmasInitialized) return;
        banner.dataset.christmasInitialized = 'true';
        const wrapper = banner.closest('.christmas-delivery-announcement');
        const root = document.documentElement;
        const deadline = Date.parse(banner.dataset.christmasDeadline);
        const timer = banner.querySelector('.christmas-delivery-banner__timer');
        let interval;
        let expiryTimeout;
        let observer;
        let stopped = false;
        let previousHeight = -1;
        const signalHeightChange = () => window.dispatchEvent(new Event('christmas:visibilitychange'));
        function stop() {
          if (stopped) return;
          stopped = true;
          clearInterval(interval);
          clearTimeout(expiryTimeout);
          if (observer) observer.disconnect();
          wrapper.style.display = 'none';
          root.style.removeProperty('--christmas-delivery-height');
          root.classList.remove('christmas-delivery-active');
          signalHeightChange();
        }
        function measure() {
          if (stopped) return;
          const height = wrapper.getBoundingClientRect().height;
          if (height !== previousHeight) {
            previousHeight = height;
            root.style.setProperty('--christmas-delivery-height', `${height}px`);
            signalHeightChange();
          }
        }
        function tick() {
          if (!Number.isFinite(deadline) || deadline <= Date.now()) {
            stop();
            return;
          }
          const seconds = Math.floor((deadline - Date.now()) / 1000);
          const days = Math.floor(seconds / 86400);
          const hours = Math.floor(seconds % 86400 / 3600);
          const minutes = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
          const remainder = String(seconds % 60).padStart(2, '0');
          timer.textContent = `${days}d ${hours}h ${minutes}m ${remainder}s`;
          measure();
        }
        if (!wrapper || !timer || !Number.isFinite(deadline) || new Date(deadline).toISOString().replace('.000Z', 'Z') !== banner.dataset.christmasDeadline || deadline <= Date.now()) {
          if (wrapper) stop();
          return;
        }
        root.classList.add('christmas-delivery-active');
        tick();
        observer = new ResizeObserver(measure);
        observer.observe(wrapper);
        interval = setInterval(tick, 1000);
        expiryTimeout = setTimeout(stop, Math.min(deadline - Date.now(), 2147483647));
        document.addEventListener('visibilitychange', tick);
        window.addEventListener('pageshow', tick);
        document.addEventListener('shopify:section:unload', event => {
          if (wrapper.id === `shopify-section-${event.detail.sectionId}`) stop();
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeChristmasBanner, { once: true });
    else initializeChristmasBanner();
    document.addEventListener('shopify:section:load', initializeChristmasBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lazy-season-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lazy-hero-slideshow')) {
    customElements.define('lazy-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.lazy-season-hero__slide'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.querySelector('.lazy-season-hero__controls').hidden = false;
        this.show(0);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-slide]');
          if (!button) return;
          const requested = Number(button.dataset.slide);
          if (requested === this.index) {
            this.paused = !this.paused;
          } else {
            this.paused = true;
            this.show(requested);
          }
          this.updateLabels();
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.schedule(); }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');
          this.schedule();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.paused = true;
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.indexOf(event.target.closest('.lazy-season-hero__slide'));
          if (index < 0) return;
          this.paused = true;
          this.show(index);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateLabels();
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.2 });
        this.observer.observe(this);
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.updateLabels();
      }
      updateLabels() {
        this.dots.forEach((button, i) => {
          const active = i === this.index;
          button.setAttribute('aria-current', String(active));
          button.setAttribute('aria-label', active ? (this.paused ? button.dataset.playLabel : button.dataset.pauseLabel) + ' — ' + button.dataset.name : button.dataset.showLabel + ' ' + button.dataset.name);
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lazy-season-intro-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lazy-season-intro-video')) {
    customElements.define('lazy-season-intro-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-video-toggle]');
        if (!this.video || !this.toggle) return;
        this.abort = new AbortController();
        this.manualPause = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        const update = () => {
          const paused = this.video.paused;
          this.toggle.textContent = paused ? 'Play' : 'Pause';
          this.toggle.setAttribute('aria-label', paused ? 'Play Video' : 'Pause Video');
          this.toggle.setAttribute('aria-pressed', String(!paused));
        };
        const play = () => this.video.play().then(update).catch(update);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.manualPause = false;
            play();
          } else {
            this.manualPause = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('play', update, options);
        this.video.addEventListener('pause', update, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
          else if (this.isVisible && !this.manualPause) play();
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          if (!this.isVisible || this.motion.matches || this.manualPause) this.video.pause();
          else play();
        }, { threshold: .25 });
        this.observer.observe(this);
        if (this.motion.matches) this.video.pause();
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lazy-season-setups"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('lazy-season-card-controller')) {
  class LazyCardController extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-lazy-setup-viewers]');
      this.onClick = this.handleClick.bind(this);
      this.root.addEventListener('click', this.onClick);
      this.onSubmit = this.addToCart.bind(this);
      this.root.addEventListener('submit', this.onSubmit);
      this.modelLoads = new Map();
      this.modelResizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          if (entry.target.dataset.ready === 'true') this.frameModel(entry.target);
        });
      });
      this.root.querySelectorAll('[data-model-host]').forEach(host => this.modelResizeObserver.observe(host));
      this.onFullscreenChange = () => {
        this.root.querySelectorAll('[data-model-fullscreen]').forEach(button => {
          button.textContent = document.fullscreenElement === button.closest('[data-model-host]') ? this.root.dataset.modelCollapse : this.root.dataset.modelExpand;
        });
      };
      document.addEventListener('fullscreenchange', this.onFullscreenChange);
      this.onVideoClose = this.finishVideo.bind(this);
      this.root.querySelectorAll('[data-video-dialog]').forEach(dialog => dialog.addEventListener('close', this.onVideoClose));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            if(entry.target.querySelector('[data-viewer-host]')) this.activate(entry.target);
            this.observer.unobserve(entry.target);
          }
        });
      }, {rootMargin:'250px'});
      this.root.querySelectorAll('[data-story]').forEach(panel => this.observer.observe(panel));
    }
    disconnectedCallback() {
      this.root.removeEventListener('click', this.onClick);
      this.root.removeEventListener('submit', this.onSubmit);
      this.modelLoads.forEach(timer => clearTimeout(timer));
      this.modelLoads.clear();
      this.modelResizeObserver.disconnect();
      document.removeEventListener('fullscreenchange', this.onFullscreenChange);
      this.observer.disconnect();
      if (this.activeDialog) {
        this.activeDialog.close();
        this.finishVideo();
      }
      this.root.querySelectorAll('[data-video-dialog]').forEach(dialog => dialog.removeEventListener('close', this.onVideoClose));
    }
    async addToCart(event) {
      const form = event.target.closest('[data-setup-cart]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (this.cartPending || button.disabled) return;
      this.cartPending = true;
      const label = button.textContent;
      const status = form.querySelector('[data-cart-status]');
      status.textContent = '';
      button.disabled = true;
      button.textContent = this.root.dataset.cartLoading;
      form.setAttribute('aria-busy', 'true');
      const cartUrl = this.root.dataset.cartUrl;
      let cartAdded = false;
      try {
        const cartResponse = await fetch(`${cartUrl}.js`);
        if (!cartResponse.ok) throw new Error(this.root.dataset.cartError);
        const cart = await cartResponse.json();
        if (cart.items.some(item => item.gift_card)) throw new Error(this.root.dataset.cartGiftError);
        const data = new FormData(form);
        if (form.dataset.breakdown === 'true') {
          try {
            const breakdown = await fetch('https://mehmbrane.com/api/shopify/pos/products/breakdown-set', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({sku: form.dataset.sku}), signal: AbortSignal.timeout(3000)
            });
            const result = await breakdown.json();
            if (breakdown.ok && result.success && result.setItems) data.set('properties[__setItems]', JSON.stringify(result.setItems));
          } catch (error) {}
        }
        const response = await fetch(`${cartUrl}/add.js`, {method: 'POST', body: data});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.root.dataset.cartError);
        cartAdded = true;
        status.textContent = this.root.dataset.cartAdded;
        if (this.root.dataset.cartBehaviour === 'page' || typeof window.open_slider_cart !== 'function' || typeof window.update_cart_content !== 'function') {
          window.location.assign(cartUrl);
          return;
        }
        window.update_cart_content();
        window.open_slider_cart();
      } catch (error) {
        if (cartAdded) window.location.assign(cartUrl);
        else status.textContent = error.message || this.root.dataset.cartError;
      } finally {
        this.cartPending = false;
        button.disabled = false;
        button.textContent = label;
        form.removeAttribute('aria-busy');
      }
    }
    async activate(panel) {
      const host = panel.querySelector('[data-viewer-host]');
      if (host.childElementCount || host.dataset.loading) return;
      host.dataset.loading = 'true';
      const status = panel.querySelector('[data-viewer-status]');
      status.textContent = 'Loading 360°…';
      try {
        if (!customElements.get('cylindo-viewer')) {
          window.lazySeasonCylindo = window.lazySeasonCylindo || import('https://viewer-cdn.cylindo.com/v1/index.mjs');
          await window.lazySeasonCylindo;
          await Promise.race([customElements.whenDefined('cylindo-viewer'), new Promise((_, reject) => setTimeout(() => reject(new Error('Viewer unavailable')), 15000))]);
        }
        if (!host.isConnected) return;
        const viewer = document.createElement('cylindo-viewer');
        viewer.setAttribute('customer-id','5059');
        viewer.setAttribute('code',host.dataset.code);
        viewer.setAttribute('configuration',host.dataset.configuration);
        viewer.setAttribute('controls','fullscreen zoom');
        viewer.setAttribute('format','png');
        viewer.setAttribute('analytics-mode','none');
        viewer.append(document.createElement('cylindo-360'));
        const timer = setTimeout(() => {
          if (!viewer.loaded) {
            viewer.remove();
            panel.querySelector('[data-poster]').hidden = false;
            host.dataset.loading = '';
            status.textContent = 'Still image shown · retry 360° View';
          }
        }, 20000);
        viewer.addEventListener('loaded', () => {
          clearTimeout(timer);
          if (panel.dataset.viewerMode !== 'model') status.textContent = '360° · Drag to explore';
          panel.querySelector('[data-poster]').hidden = true;
        });
        host.append(viewer);
      } catch(error) {
        host.dataset.loading = '';
        window.lazySeasonCylindo = null;
        status.textContent = 'Still image shown · retry 360° View';
      }
    }
    frameModel(host, initial = false) {
      const model = host.querySelector('model-viewer');
      if (!model || !model.clientWidth || !model.clientHeight) return;
      const dimensions = model.getDimensions();
      const aspect = model.clientWidth / model.clientHeight;
      const orbit = model.getCameraOrbit();
      const theta = initial ? Number(host.dataset.cameraAngle || 0) : orbit.theta * 180 / Math.PI;
      const phi = initial ? Number(host.dataset.cameraPolar || 75) : orbit.phi * 180 / Math.PI;
      const angle = theta * Math.PI / 180;
      const projectedWidth = dimensions.x * Math.abs(Math.cos(angle)) + dimensions.z * Math.abs(Math.sin(angle));
      const distance = Math.max(projectedWidth / (2 * Math.tan(Math.PI / 12) * aspect * 0.82), dimensions.z * 1.5);
      model.setAttribute('camera-orbit', `${theta}deg ${phi}deg ${distance}m`);
      model.jumpCameraToGoal();
    }
    activateModel(panel, option) {
      if (!option.matches('[data-lounge-preset]')) option = panel.querySelector('[data-lounge-preset][aria-pressed="true"]') || option;
      const source = option.value || option.dataset.model;
      const state = option.dataset.name || option.dataset.state;
      const description = option.dataset.description || '';
      const host = panel.querySelector('[data-model-host]');
      host.dataset.cameraAngle = option.dataset.angle || '0';
      host.dataset.cameraPolar = option.dataset.polar || '75';
      host.setAttribute('aria-label', `360 degree view of ${panel.querySelector('h3').textContent} — ${state}`);
      const layoutDescription = host.querySelector('[data-lounge-description]');
      if (layoutDescription) layoutDescription.textContent = description;
      const status = panel.querySelector('[data-viewer-status]');
      const loading = host.querySelector('[data-model-loading]');
      const existing = host.querySelector('model-viewer');
      if (existing && existing.getAttribute('src') === source) {
        if (host.dataset.ready === 'true') this.frameModel(host);
        status.textContent = host.dataset.ready === 'true' ? '360° · Drag to explore' : loading.textContent;
        return;
      }
      clearTimeout(this.modelLoads.get(host));
      this.modelLoads.delete(host);
      if (existing) existing.remove();
      host.dataset.ready = '';
      host.querySelector('[data-model-fullscreen]').hidden = true;
      loading.hidden = false;
      loading.textContent = this.root.dataset.modelLoading;
      status.textContent = loading.textContent;
      const model = document.createElement('model-viewer');
      model.setAttribute('data-shopify-feature', '1.12');
      model.setAttribute('src', source);
      model.setAttribute('alt', `${panel.querySelector('h3').textContent} — ${state}. ${description}`);
      model.setAttribute('camera-controls', '');
      model.setAttribute('touch-action', 'pan-y');
      model.setAttribute('camera-orbit', '0deg 75deg 105%');
      model.setAttribute('field-of-view', '30deg');
      model.setAttribute('max-camera-orbit', 'auto 90deg auto');
      model.setAttribute('disable-pan', '');
      model.setAttribute('environment-image', 'neutral');
      model.setAttribute('exposure', option.dataset.exposure || '1.25');
      model.setAttribute('shadow-intensity', '1');
      model.setAttribute('shadow-softness', '1');
      model.setAttribute('interaction-prompt', 'none');
      const fail = () => {
        clearTimeout(timer);
        if (host.querySelector('model-viewer') !== model) return;
        this.modelLoads.delete(host);
        host.dataset.ready = '';
        model.remove();
        loading.textContent = this.root.dataset.modelError;
        if (panel.dataset.viewerMode === 'model') status.textContent = this.root.dataset.modelError;
      };
      const timer = setTimeout(fail, 60000);
      this.modelLoads.set(host, timer);
      model.addEventListener('error', fail, {once:true});
      model.addEventListener('load', () => {
        clearTimeout(timer);
        if (host.querySelector('model-viewer') !== model) return;
        this.modelLoads.delete(host);
        host.dataset.ready = 'true';
        this.frameModel(host, true);
        loading.hidden = true;
        host.querySelector('[data-model-fullscreen]').hidden = !host.requestFullscreen;
        if (panel.dataset.viewerMode === 'model') status.textContent = '360° · Drag to explore';
      }, {once:true});
      host.append(model);
    }
    openVideo(panel, opener) {
      const dialog = panel.querySelector('[data-video-dialog]');
      if (!dialog || dialog.open || this.activeDialog) return;
      const video = dialog.querySelector('video');
      this.activeDialog = dialog;
      this.videoOpener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      video.preload = 'auto';
      video.currentTime = 0;
      video.play().catch(() => {});
    }
    finishVideo() {
      if (!this.activeDialog) return;
      this.activeDialog.querySelector('video').pause();
      document.documentElement.style.overflow = this.previousOverflow;
      const opener = this.videoOpener;
      this.activeDialog = null;
      this.videoOpener = null;
      if (opener && opener.isConnected) opener.focus({preventScroll:true});
    }
    handleClick(event) {
      const close = event.target.closest('[data-video-close]');
      if (close) {
        close.closest('[data-video-dialog]').close();
        return;
      }
      const panel = event.target.closest('[data-story]');
      if(!panel) return;
      const expand = event.target.closest('[data-model-fullscreen]');
      if (expand) {
        const host = panel.querySelector('[data-model-host]');
        if (document.fullscreenElement) document.exitFullscreen();
        else host.requestFullscreen().catch(() => {});
        return;
      }
      const preset = event.target.closest('[data-lounge-preset]');
      if (preset) {
        panel.querySelectorAll('[data-lounge-preset]').forEach(button => button.setAttribute('aria-pressed',String(button === preset)));
        this.activateModel(panel, preset);
        return;
      }
      const option = event.target.closest('[data-state]');
      if(option) {
        panel.querySelectorAll('[data-state]').forEach(button => button.setAttribute('aria-pressed',String(button === option)));
        const modelHost = panel.querySelector('[data-model-host]');
        panel.dataset.viewerMode = option.dataset.model ? 'model' : 'spin';
        panel.querySelector('[data-render]').hidden = Boolean(option.dataset.model);
        if (modelHost) modelHost.hidden = !option.dataset.model;
        if (option.dataset.model) {
          this.activateModel(panel, option);
          return;
        }
        panel.querySelector('[data-viewer-status]').textContent = '360° · Drag to explore';
        const host = panel.querySelector('[data-viewer-host]');
        host.dataset.code = option.dataset.code;
        host.dataset.configuration = option.dataset.configuration;
        const viewer = host.querySelector('cylindo-viewer');
        if(viewer) {
          viewer.setAttribute('code',option.dataset.code);
          viewer.setAttribute('configuration',option.dataset.configuration);
        }
        const poster = panel.querySelector('[data-poster]');
        const params = new URLSearchParams({size:'1200'});
        option.dataset.configuration.split(',').forEach(feature => params.append('feature',feature));
        poster.src = `https://content.cylindo.com/api/v2/5059/products/${option.dataset.code}/frames/1/${option.dataset.code}.png?${params}`;
        poster.alt = `${panel.querySelector('h3').textContent} — ${option.dataset.state}`;
        this.activate(panel);
      }
      const media = event.target.closest('[data-media]');
      if (media) {
        if (media.dataset.media === 'video') this.openVideo(panel, media);
        else {
          const selectedModel = panel.querySelector('[data-model][aria-pressed="true"]');
          if (selectedModel) this.activateModel(panel, selectedModel);
          else this.activate(panel);
        }
      }
    }
  }
  customElements.define('lazy-season-card-controller',LazyCardController);
}
function mountLazySetupCards(container) {
  container.querySelectorAll('[data-lazy-setup-viewers]').forEach(root => {
    if(!root.querySelector('lazy-season-card-controller')) root.append(document.createElement('lazy-season-card-controller'));
  });
}
mountLazySetupCards(document);
document.addEventListener('shopify:section:load',event => mountLazySetupCards(event.target));

  } catch(e) { console.error(e); }
})();
})();
